export default __webpack_public_path__ + "static/media/cp_geo_cm.eb4cbbfe.svg";